<template>
    <div>
        <div
            :key="creatorGallery.gallery.id"
            v-for="creatorGallery in creatorGalleries"
            class="p-2 bg-light"
        >
            <gallery-index-item
                class="mt-3 rounded border"
                :creatorGallery="creatorGallery.gallery"
                :purchased="creatorGallery.purchased"
            />
        </div>

        <div
            v-if="showPagination"
            class="d-flex align-items-center justify-content-between p-3"
        >
            <div>
                <b-btn
                    @click="previous"
                    variant="light"
                    size="lg"
                    block
                    pill
                    class="p-3 border-0 d-flex align-items-center"
                    :disabled="page === 1"
                >
                    <font-awesome-icon icon="fa-light fa-arrow-left" />
                    <div class="ml-2 d-none d-md-block">
                        {{ $t("Previous") }}
                    </div>
                </b-btn>
            </div>
            <div class="text-center text-secondary">Page {{ page }}</div>
            <div>
                <b-btn
                    @click="next"
                    variant="light"
                    size="lg"
                    block
                    pill
                    class="p-3 border-0 d-flex align-items-center"
                    :disabled="!hasMorePages"
                >
                    <div class="mr-2 d-none d-md-block">
                        {{ $t("Next") }}
                    </div>
                    <font-awesome-icon icon="fa-light fa-arrow-right" />
                </b-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import GalleryIndexItem from "@/components/galleryIndex/GalleryIndexItem";

export default {
    data() {
        return {
            creatorGalleries: null,
            hasMorePages: false,
            page: 1,
        };
    },
    computed: {
        showPagination() {
            if (!this.hasMorePages && this.page === 1) {
                return false;
            }

            return true;
        },
        ...mapState("profile", ["profile"]),
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.creatorGalleries = null;

            this.api
                .post("/creatorGallery/index", {
                    userId: this.profile.id,
                    page: this.page,
                })
                .then((response) => {
                    if (response?.data?.creatorGalleries) {
                        this.creatorGalleries = response.data.creatorGalleries;
                    }

                    this.hasMorePages = response.data.hasMorePages;
                });
        },
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
    },
    components: {
        GalleryIndexItem,
    },
};
</script>